import { render, staticRenderFns } from "./PagedTableViewSimple.vue?vue&type=template&id=ac3624f4&scoped=true&"
import script from "./PagedTableViewSimple.vue?vue&type=script&lang=ts&"
export * from "./PagedTableViewSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3624f4",
  null
  
)

export default component.exports